var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _mask, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWomanChillingOut = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 596 696"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M41.49 359.272a4.89 4.89 0 0 1-5.72-2.571 3.32 3.32 0 0 1 .44-3.58l3.898-4.656c2.001-2.39 4.57-4.233 7.438-5.454 3.047-1.297 7.154-3.125 10.55-4.919 9.013-4.761 18.855-8.054 29.044-7.751l34.552 1.026 8.59-10.097v31l-25.098 2.245a76 76 0 0 1-18.835-.661l-7.303-1.174s-6.82-1.475-12.047-.317c-3.908.865-18.427 4.918-25.509 6.909Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m204.5 46.536-12.5 40.5 24.34 6.523 11.613-46.853z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M184.013 90.579c19.797-.684 33.566 19.475 25.728 37.667l-42.982 99.765-26.015 98.344a9.814 9.814 0 0 1-9.632 7.302c-28.623-.424-47.739-29.66-36.648-56.051l6.818-16.225 59.5-170z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m225.18 60.798-6.967 26.031 1.932.517 6.967-26.03zm-41 23.617 16.547-47.707-1.89-.655-16.546 47.707z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  d: "m218.213 86.83-.259.965-.966-.258.259-.966zm6.967-26.032-.966-.259.258-.965.966.258zm-5.035 26.548.966.259-.259.966-.966-.259zm6.967-26.03.258-.967.966.259-.258.966zm-26.385-24.607.327-.945.945.327-.327.945zM184.18 84.415l.945.328-.328.945-.944-.328zm14.657-48.362-.945-.328.328-.944.945.327zM182.291 83.76l-.328.945-.945-.328.328-.945zm34.956 2.81 6.967-26.03 1.932.517-6.967 26.03zm2.639 1.742-1.932-.517.517-1.932 1.932.517zm8.192-26.738-6.967 26.03-1.932-.516 6.967-26.031zm-2.64-1.742 1.932.517-.517 1.932-1.932-.517zm-23.766-22.796-16.547 47.707-1.889-.655 16.546-47.707zm-2.507-1.928 1.889.656-.655 1.89-1.89-.656zm-17.819 48.324 16.546-47.707 1.89.656-16.546 47.707zm2.507 1.928-1.89-.655.655-1.89 1.89.656z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M358.716 319.308a3.623 3.623 0 1 0 1.008-7.176 3.623 3.623 0 0 0-1.008 7.176ZM370.674 320.989a3.623 3.623 0 1 0 1.009-7.175 3.623 3.623 0 0 0-1.009 7.175ZM382.633 322.67a3.623 3.623 0 1 0 1.009-7.175 3.623 3.623 0 0 0-1.009 7.175Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "m218.769 66.185-1.09 21.97 1.189-1.85 5.414-18.424z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m467.112 318.407 61.682 18.363-44-40-46.685-141.836c-8.837-26.849-42.41-35.673-63.307-16.64L262.294 240.77s-55.42-4.883-82.068 14.484-1.444 28.516-1.444 28.516l32.658 37.685c15.772 18.199 44.451 16.72 58.267-3.006L376.294 166.27z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M550.258 336.213c5.867 1.976 8.323 8.932 4.999 14.154l-68.5 1.337a8 8 0 0 1-5.809-2.337l-17.262-17.236 2.49 19.423h-21.382l3.109-49.316a5.834 5.834 0 0 1 5.822-5.468s33.688 19.425 51.793 27.392c18.106 7.967 8.965 0 8.965 0z",
  clipRule: "evenodd"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m413.282 282.77 103 2.5-84.508-163.588c-12.118-23.458-43.556-28.347-62.226-9.677L238.282 243.27s-34.256.236-51.056 12.446c-26.648 19.367-13.263 23.379-13.263 23.379l62.175 49.212c16.267 12.876 39.941 9.861 52.463-6.68l98.681-130.357z",
  clipRule: "evenodd"
})), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "woman-chilling-out_svg__a",
  width: 412,
  height: 401,
  x: 160,
  y: 39,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m413.282 282.77 103 2.5-84.508-163.588c-12.118-23.458-43.556-28.347-62.226-9.677L238.282 243.27s-34.256.236-51.056 12.446c-26.648 19.367-13.263 23.379-13.263 23.379l62.175 49.212c16.267 12.876 39.941 9.861 52.463-6.68l98.681-130.357z",
  clipRule: "evenodd"
}))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M314.686 606.77s-3.086 44.753 24.596 52c.585.154 16-9.5 16-9.5v-55l125.399-255.306c12.729-25.914-6.134-56.194-35.005-56.194H261.782s-40.681-35.159-73.443-38.597-25.5 8.5-25.5 8.5l12.844 55.885c3.862 16.804 18.818 28.712 36.06 28.712h184.539z",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m383.282 589.77 105.792-261.367c10.377-25.639-8.492-53.633-36.151-53.633H260.782s-39.42-26.792-72.182-30.231-25.5 8.5-25.5 8.5l2.391 63.132c.752 19.875 17.083 35.599 36.973 35.599h185.318l-73.5 140z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M156.017 112.034c1.153-17.391 17.31-29.734 34.421-26.414a14.6 14.6 0 0 0 2.714.266l38.348.15-39.552 133.63 9.711 25.617-40.377 6.987s-9.462-8.508-10-39.5c-.341-19.644 2.563-67.976 4.735-100.736ZM379.996 279.146a4.89 4.89 0 0 0 5.474-3.06 3.32 3.32 0 0 0-.751-3.528l-4.288-4.298c-2.202-2.207-4.921-3.819-7.885-4.786-3.148-1.026-7.399-2.49-10.938-3.981-9.394-3.957-19.486-6.379-29.61-5.19l-34.33 4.034-19.874 2.992 10.828 14.786 23.613 2.464a76 76 0 0 0 26.448-1.89l3.325-.837s6.666-2.064 11.975-1.366c3.968.522 18.785 3.294 26.013 4.66Z",
  clipRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M241.23 83.512c7.943-.512 14.575 5.98 14.232 13.931l-5.68 131.827 68.069 20.838a7.68 7.68 0 0 1 5.431 7.342c0 15.906-11.817 29.336-27.594 31.361l-75.8 9.725c-17.27 2.215-32.353-11.701-31.532-29.093l6.552-138.804c1.19-25.212 21.135-45.503 46.322-47.127Z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M372.891 676.095c3.131 5.34.422 12.202-5.513 13.962l-52.575-43.931a8 8 0 0 1-2.85-5.575l-1.72-24.334-10.864 16.293-16.137-14.028 34.701-35.18a5.835 5.835 0 0 1 7.981-.306s12.68 36.762 21.118 54.652 6.765 5.881 6.765 5.881z",
  clipRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m198.089 42.062 3.599-15.59c4.686-15.852 21.041-20.899 35.283-13.494 15.457 8.038 16.022 18.022 14.034 35.524-1.988 17.501-7.849 25.586-24.249 20.572-5.222-1.597-12.404-6.323-12.404-6.323",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m198.089 42.062 3.599-15.59c4.686-15.852 21.041-20.899 35.283-13.494 15.457 8.038 16.022 18.022 14.034 35.524-1.988 17.501-7.849 25.586-24.249 20.572-5.222-1.597-12.404-6.323-12.404-6.323"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M205.482 49.733c-2.673-2.744-3.778-6.99-2.517-11.111 1.794-5.868 7.702-9.264 13.195-7.584a9.9 9.9 0 0 1 4.844 3.305",
  clipRule: "evenodd"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M205.482 49.733c-2.673-2.744-3.778-6.99-2.517-11.111 1.794-5.868 7.702-9.264 13.195-7.584a9.9 9.9 0 0 1 4.844 3.305"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M210.907 31.034s3.291-1.288 4.834-.937c2.486.566 4.885 3.147 5.884 3.411 6.788 1.795 23.157-16.738 23.157-16.738s-16.474-7.698-23.768-7.44c-4.227.15-9.263 3.652-12.752 6.571-2.923 2.446-4.84 5.82-5.978 9.458l-5.873 18.776s4.434 5.16 5.371 5.746 3.732-.05 3.732-.05-.629-1.788-1.729-3.507c-.975-1.524-2.403-3.297-2.152-5.006.8-5.456 9.274-10.284 9.274-10.284",
  clipRule: "evenodd"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M249.782 228.173v15z",
  clipRule: "evenodd"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#5850EC",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M249.782 228.173v15"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#5850EC",
  fillRule: "evenodd",
  d: "M205.282 49.77s1.5 10.5-2 23-11.5 17.5-21 24-21.759 8.631-26.5 5.5c-4.741-3.13-7.5-12 0-23s16.142-.62 26.5-13c7.858-9.391 23-46 23-46s-5 13.334-5 19 5 10.5 5 10.5",
  clipRule: "evenodd"
})));
export default SvgWomanChillingOut;